import React from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * ButtonsShowcase Component
 * Displays button variants with theme styling
 */
const ButtonsShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Typography variant="subtitle2" gutterBottom>
        Buttons
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: theme.primary_color,
            fontFamily: theme.font_family,
            fontSize: theme.font_size,
          }}
        >
          Primary Button
        </Button>
        <Button
          variant="outlined"
          sx={{
            borderColor: theme.secondary_color,
            color: theme.secondary_color,
            fontFamily: theme.font_family,
            fontSize: theme.font_size,
          }}
        >
          Secondary Button
        </Button>
        <Button
          variant="text"
          sx={{
            color: theme.accent_color,
            fontFamily: theme.font_family,
            fontSize: theme.font_size,
          }}
        >
          Text Button
        </Button>
      </Box>
    </Grid>
  );
};

ButtonsShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default ButtonsShowcase;
